import { createSelector } from 'reselect';

const isEditingTag = state => state.tags.isEditingTag;
const list = state => state.tags.list;

const userTags = createSelector([list], (tags) => {
  if (tags) {
    return tags.filter((tag) => {
      return tag.for === 'user';
    });
  }
  return [];
});

const editingTag = createSelector([list, isEditingTag], (tags, tagGuid) => {
  const editing = !tags ? null : tags.find(tag => tag.guid === tagGuid);
  return !editing ? null : editing;
});

const taskGroupTags = createSelector([list], (tags) => {
  if (tags) {
    return tags.filter((tag) => {
      return tag.for === 'task-group';
    });
  }
  return [];
});

export default {
  editingTag,
  taskGroupTags,
  userTags,
};
